/* eslint-disable no-unused-vars */
/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getReportDetail({ commit }, { query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`teachers/statistics?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_REPORT_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  downloadReport({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `teachers/download-statistics/?${new URLSearchParams(query)}`,
          null,
          {
            responseType: "arraybuffer",
          },
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getListReport({ commit }, { query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`teachers/list-statistics?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_LIST_REPORT", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getListSalarySetting() {
    return new Promise((resolve, reject) => {
      axios
        .get(`teachers/salary-setting`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateSalarySetting({ commit }, { payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`teachers/salary-setting/${payload.id}`, payload)
        .then((response) => {
          commit("UPDATE_SALARY_SETTING", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createSalarySetting({ commit }, { payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`teachers/salary-setting`, payload)
        .then((response) => {
          // commit('UPDATE_SALARY_SETTING', response.data.data)
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSalarySettingTeacher({ commit }, { payload }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`teachers/salary-setting/${payload.teacherId}`)
        .then((response) => {
          commit("SET_SALARY_SETTING", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSalarySettingHistory({ commit }, { payload }) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `teachers/salary-setting/history/${payload.teacherId}/${payload.settingId}`,
        )
        .then((response) => {
          commit("SET_SALARY_SETTING_HISTORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setFilters({ commit }, data) {
    commit("SET_FILTERS", data);
  },
};
